import { styleConfig, typesConfig } from "../config";
import { loggingHelper } from "../helper";

function changeStyle({ frame, style }) {
	if (!frame) {
		loggingHelper.warn("frame does not exist", frame);
		return;
	}

	Object.keys(style).forEach((key) => {
		frame.style[key] = style[key];
	});
}
function addFrameToDocument(frame) {
	(document.getElementsByTagName("body")[0] || document.getElementsByTagName("html")[0]).appendChild(frame);
}

function hideFrame(frame) {
	frame.style.display = "none"
}

function showFrame(frame) {
	frame.style.display = "block";
}

export default {
	createIframe({ src, id, title, hidden, style = styleConfig.styleBeforeLoad }) {
		const frame = document.createElement("iframe");

		frame.allowFullscreen = true;
		frame.src = src;
		frame.id = id;
		frame.title = title;

		changeStyle({ frame, style });

		if(hidden) {
			frame.style.display = "none";
		}

		addFrameToDocument(frame);

		return frame;
	},
	createChildIframe({ src, id, title, container, style = styleConfig.styleBeforeLoad }) {
		const frame = document.createElement("iframe");

		frame.src = src;
		frame.id = id;
		frame.title = title;
		frame.allowFullscreen = true;

		changeStyle({ frame, style });
		document.querySelector(container) && document.querySelector(container).appendChild(frame);

		return frame;
	},
	changeStyle,
	hideFrame,
	hideFrames(frames) {
		for (let key of Object.keys(frames)) {
			if (key !== typesConfig.apps.flow) {
				hideFrame(frames[key]);
			}
		}
		window.Bothive.widget.hidden = true;
	},
	showFrame,
	showFrames(frames) {
		for (let key of Object.keys(frames)) {
			showFrame(frames[key]);
		}
		window.Bothive.widget.hidden = false;
	},
	existingFramesPresent: (frameIds) => frameIds.find(item => document.getElementById(item)),
}
